import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-small",
  "use": "arrow-down-small-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" id=\"arrow-down-small\"><path fill=\"none\" d=\"M4 1v6m3-3L4 7 1 4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol